import Link from 'next/link';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { IndentContainer } from '@r1-frontend/ui-react/experimental/containers';

import { PromoParagraph1, PromoTextWithStyleHeading2, TextWrapper } from '~/src/features/internetV2/components/typography';

import * as ST from './styled';

export interface ISquareBannerProps {
    backgroundImage: string,
    backgroundImageWebp: string,
    title: React.ReactNode,
    description: React.ReactNode,
    buttonText?: string,
    key?: string,
    buttonHref?: string,
    onButtonClick?: () => void,
}

const SquareBanner = ({
    backgroundImage,
    backgroundImageWebp,

    title,
    description,
    buttonText,
    buttonHref = '',
    onButtonClick,

    key,
}: ISquareBannerProps): JSX.Element => {
    return (
        <ST.RounderContainerWithImage
            key={key}
            $desktop={32}
            $mobile={24}
            backgroundImage={backgroundImage}
            backgroundImageWebp={backgroundImageWebp}
        >
            <TextWrapper>
                <PromoTextWithStyleHeading2>{title}</PromoTextWithStyleHeading2>
                <PromoParagraph1>{description}</PromoParagraph1>
                <IndentContainer $united={[8, 0, 0]}>
                    {
                        buttonText && (
                            <Link href={buttonHref}>
                                <Button bType={'primary'} onClick={onButtonClick}>{buttonText}</Button>
                            </Link>
                        )
                    }
                </IndentContainer>
            </TextWrapper>
        </ST.RounderContainerWithImage>
    );
};

export default SquareBanner;
